<template>
  <div>
    <ul>
      <li v-for="(item,index) in node" :key="index">
        <div class="border">
          <p>{{item.title}}</p>
          <editFolder :item="item" :scriptID="scriptID"></editFolder>
        </div>

        <editScriptR :parentID="item.id" :scriptID="scriptID"></editScriptR>
        <addItem v-if="item.template === 'folder'" :item="item" :scriptID="scriptID"></addItem>
      </li>
      <li  v-if="parentID == '0'" >
        <addItem :item="{id:parentID,title:getScriptNameByID(scriptID)}"
                 :scriptID="scriptID"></addItem>
      </li>
    </ul>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  export default {
    name: "editScript",
    props:{
      parentID:{
        type:String,
        default:"0"
      },
      scriptID:{
        type:String,
        default:"0"
      }
    },
    components:{
      addItem:()=>import('@/components/OperatorScript/editScriptAddItem'),
      editScriptR:()=>import('@/components/OperatorScript/editScript'),
      editFolder:()=>import('@/components/OperatorScript/editScriptsEditFolder'),
    },
    computed:{
      node() {
        let uiiii = this.getScripts(this.scriptID);
        if (uiiii.length > 0) {
          return uiiii[0].values.filter(item => item.parent_id === this.parentID);
        } else {
          return [];
        }
      },
      ...mapGetters(['getScripts','getScriptNameByID'])
    }
  }
</script>

<style scoped>
ul{text-align: left;border: 1px dotted #42b983}
  ul > li{margin: 5px 0;}
.border{border: 1px dashed #42b983;padding: 10px}
</style>
